import React, { useState, lazy } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
import { FAQSchema } from './StructuredData';
const faqs = [{
  q: 'Where is your service area?',
  a: "Our expert maids are available in Bicester and Oxfordshire. However, we are expanding our team and the area we cover every day so if you are not sure try booking online or call us. We'll confirm in seconds."
}, {
  q: 'How to book a home or commercial cleaning?',
  a: "If you're online, simply select the service you want and click the Book Online button to get personalized pricing, schedule an appointment in real-time based on our actual availability, and receive a confirmation. It only takes 60 seconds. Use your smartphone, computer, or tablet. Alternatively, call us at 07432285564 or email us at smithsandjengs@yahoo.com."
}, {
  q: 'Do I need to be at home when you arrive for the cleaning?',
  a: ''
}, {
  q: 'Do I need to supply the vacuum or cleaning products?',
  a: "We come equipped with everything we need to make your home or commercial facility sparkle. But if you'd prefer that we use your cleaning products, just let us know when you book online or by phone."
}, {
  q: 'Do you use eco-friendly cleaning products?',
  a: "Yes, we do! Part of our commitment as a member of the community is not to harm the environment. That's why we use only eco-friendly products which do just as good a cleaning job as traditional chemical cleaning products. If you prefer that we use traditional chemical products, just let us know when you book."
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="w-full bg-white py-24 px-6 md:px-12 overflow-hidden" data-id="element-62">
      <FAQSchema faqs={faqs.map(f => ({
      question: f.q,
      answer: f.a
    }))} data-id="element-63" />
      <div className="max-w-7xl mx-auto flex flex-col lg:flex-row gap-12 lg:gap-16" data-id="element-64">
        {/* Left: Accordion */}
        <motion.div initial={{
        opacity: 0,
        x: -50
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="w-full lg:w-1/2 flex flex-col" data-id="element-65">
          <div className="mb-12" data-id="element-66">
            {faqs.map((faq, idx) => <div key={idx} className="border-t border-gray-200 first:border-t-0" data-id="element-67">
                <button onClick={() => setOpenIndex(openIndex === idx ? null : idx)} className="w-full flex justify-between items-start text-left py-5 focus:outline-none group" data-id="element-68">
                  <span className="text-base md:text-lg font-bold text-[#1a2744] pr-8 leading-snug" data-id="element-69">
                    {faq.q}
                  </span>
                  <ChevronDownIcon className={`w-5 h-5 text-[#1a2744] flex-shrink-0 mt-1 transition-transform duration-300 ${openIndex === idx ? 'rotate-180' : ''}`} data-id="element-70" />
                </button>
                <AnimatePresence data-id="element-71">
                  {openIndex === idx && faq.a && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} className="overflow-hidden" data-id="element-72">
                      <p className="text-gray-500 pb-5 text-sm leading-relaxed max-w-md" data-id="element-73">
                        {faq.a}
                      </p>
                    </motion.div>}
                </AnimatePresence>
                {idx === faqs.length - 1 && <div className="border-b border-gray-200" data-id="element-74" />}
              </div>)}
          </div>

          <Link to="/faq" className="flex items-center justify-center lg:justify-start gap-4 mt-auto pt-4 group" data-id="element-75">
            <span className="font-semibold text-[#1a2744] text-sm" data-id="element-76">
              Read all our FAQs
            </span>
            <div className="w-10 h-10 rounded-full border border-[#1a2744] flex items-center justify-center group-hover:bg-[#1a2744] group-hover:text-white transition-colors" data-id="element-77">
              &rarr;
            </div>
          </Link>
        </motion.div>

        {/* Right: Title overlapping Image */}
        <motion.div initial={{
        opacity: 0,
        x: 50
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="w-full lg:w-1/2 flex flex-col" data-id="element-78">
          <div className="relative z-10" data-id="element-79">
            <h2 className="text-6xl md:text-[7rem] lg:text-[8rem] font-bebas text-[#1a2744] leading-[0.85] tracking-wide text-right" data-id="element-80">
              FREQUENTLY
              <br data-id="element-81" />
              ASKED
              <br data-id="element-82" />
              QUESTIONS
            </h2>
          </div>
          <div className="w-full h-[350px] md:h-[400px] relative -mt-12 md:-mt-20" data-id="element-83">
            <img src="https://cdn.magicpatterns.com/uploads/i1aJDrWroYYvQkM7fHpkuf/sj-website-home-img4.png" alt="Cosy well-maintained room with warm lighting and clean furnishings" className="w-full h-full object-cover" loading="lazy" data-id="element-84" />
          </div>
        </motion.div>
      </div>
    </section>;
}